import {
  // 单选、多选国家筛选器
  COMPOSED_COUNTRY_SELECT as FILTER_COMPOSED_COUNTRY_SELECT,
  // 时间筛选器
  RANGE_TIME as FILTER_RANGE_TIME,
  // 品类筛选器
  GENRETOR as FILTER_GENRE_SELECT,
  // Mobile Overlap 筛选器
  MOBILE_OVERLAP as FILTER_MOBILE_OVERLAP,
} from '@intelligence/components/Filter/FilterBase/_config';

// 筛选器默认配置
export const STATIC_FILTER_CONFIGS = {
  // 单选、多选国家筛选器
  COMPOSED_COUNTRY_SELECT: {
    key: FILTER_COMPOSED_COUNTRY_SELECT,
    type: FILTER_COMPOSED_COUNTRY_SELECT,
    visible: 1,
    disabled: false,
    isAll: false,
    isShowTypeSelect: false,
    options: [],
  },
  // 时间筛选器
  RANGE_TIME: {
    key: FILTER_RANGE_TIME,
    type: FILTER_RANGE_TIME,
    showSelectType: false,
    showShortcut: false,
    typeList: ['month'],
    visible: 1,
    calendarType: 'month',
  },
  // Mobile Overlap 筛选器
  MOBILE_OVERLAP: {
    key: FILTER_MOBILE_OVERLAP,
    type: FILTER_MOBILE_OVERLAP,
  },
};

// 筛选器默认值
export const FILTER_DEFAULT_VALUE = {
  [FILTER_COMPOSED_COUNTRY_SELECT]: {
    value: {
      type: 'single',
      countries: ['us'],
    },
  },
  [FILTER_RANGE_TIME]: {
    type: 'month',
    value: ['', ''],
  },
  [FILTER_GENRE_SELECT]: {
    source: 'iegg',
    mainGenres: [],
    subGenres: [],
  },
  [FILTER_MOBILE_OVERLAP]: {
    value: { opt: '', value: '' },
  },
};
